import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-showcarbon',
  templateUrl: './showcarbon.component.html',
  styleUrls: ['./showcarbon.component.scss']
})
export class ShowcarbonComponent implements OnInit {

  constructor(
    private dialogRef: MatDialogRef<ShowcarbonComponent>,
    @Inject(MAT_DIALOG_DATA) public showData: any,
  ) { }


  ngOnInit() {
    this.showData = [this.showData]
  }

  cancelButton() {
    this.dialogRef.close()
  }
}
